var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vendor-vacation-edit"},[_c('edit',{attrs:{"fs":_vm.vacationFields,"api":"vacations","id":_vm.id,"title":"Vacation"},on:{"saved":_vm.saved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }